import { useState, useEffect } from 'react';
import yoproductsServiceClient from '../../../common/helpers/yoproducts-service-client';

const usePrices = ({ partnerId }) => {
  const [prices, setPrices] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    let isCanceled = false;
    const yoproducts = yoproductsServiceClient.get();

    setIsLoading(true);

    yoproducts.requests
      .partnerProductsTree({ partnerId })
      .then((data) => {
        if (isCanceled) {
          return;
        }

        setPrices(data);
        setIsLoading(false);
      })
      .catch(() => {
        if (isCanceled) {
          return;
        }

        setIsLoading(false);
      });

    return () => {
      setIsLoading(false);
      isCanceled = true;
    };
  }, [partnerId]);

  return { data: prices, isLoading };
};

export default usePrices;
